module.exports = __webpack_public_path__ + "media/images/new/trail_maps@2x-1452f84bef19ac04a9e3dd6ae5ebf948.jpg";